import React from 'react'
import { Cart, VariantWithImage } from '../types'

type CartContext = {
    cart: Cart
    addCartItem: (
        variant: VariantWithImage,
        quantity?: number,
        sellingPlanId?: string | null,
        immediateCheckout?: boolean,
        shopPay?: boolean,
    ) => void
    addCartItems: (
        variants: {
            variant: VariantWithImage
            quantity?: number
            sellingPlanId?: string | null
            attributes?: { [key: string]: string | null } | undefined
        }[],
        immediateCheckout?: boolean,
        shopPay?: boolean,
    ) => void
    updateCartItem: (
        variant: VariantWithImage,
        quantity?: number,
        sellingPlanId?: string | null,
        immediateCheckout?: boolean,
        shopPay?: boolean,
        currentSellingPlanId?: string | null,
        shopifyLineId?: string,
    ) => void
    removeCartItem: (
        variant: VariantWithImage,
        sellingPlanId?: string | null,
        shopifyLineId?: string,
    ) => void
    onCheckout: (shopPay?: boolean) => void
    // Cart calculation methods
    getCartSubtotal: () => number
    getCartTotal: () => number
}

const DefaultCartContext: CartContext = {
    cart: { items: [], id: '' },
    addCartItem: () => {},
    addCartItems: () => {},
    updateCartItem: () => {},
    removeCartItem: () => {},
    onCheckout: (_shopPay?: boolean) => {},
    // Default implementations for cart calculation methods
    getCartSubtotal: () => 0,
    getCartTotal: () => 0,
}

export const CartContext = React.createContext(DefaultCartContext)
